<script lang="ts" setup>
import { ref, computed, onMounted, nextTick } from "vue";
import CmsTextRender from '@/components/shared/CmsTextRender.vue';
import { useTableWrapper } from '~/composables/useTableWrapper'

import type { CmsElementCategoryDescriptionSeo } from "~/composables/useCustom";

const props = defineProps<{ content: CmsElementCategoryDescriptionSeo }>();

const { title, descriptionText } = props.content.data;

const isExpanded = ref(false);
const maxLength = 100;
const { wrapTables } = useTableWrapper();
const descriptionRef = ref<HTMLElement | null>(null);

onMounted(() => {
  nextTick(() => {
    wrapTables(descriptionRef);
  });
});
</script>

<template>
  <div
    class="category-description py-16 border-t border-grey-100"
    role="region"
    :aria-label="$t('productListing.ariaLabelCategoryDescription')">
    <div class="category-description-inner relative">
      <div class="title" v-if="title">
        <h2
          id="about-title"
          class="heading text-2xl lg:text-6xl 3xl:text-10xl font-marcellus text-grey-700 md:leading-none leading-[32px]">
          {{ title }}
        </h2>
      </div>
      <div class="content mt-7 lg:mt-10" v-if="descriptionText" >
        <div
          :class="[
            'relative overflow-y-hidden transition-all duration-500 ease-in-out',
            isExpanded ? 'max-h-[10000px]' : 'max-h-[100px]' 
          ]"
        >
          <div
            ref="descriptionRef"
            class="description-content msb-cms-text-content"
          >
            <CmsTextRender class="[&_p]:mb-[15px] [&_.is-tipp]:block [&_.is-tipp]:bg-light-grey [&_.is-tipp]:py-5 [&_.is-tipp]:px-2.5  [&_.is-tipp]:my-5" :content="{ data: { text: descriptionText } }" />
          </div>
          <div
            v-if="!isExpanded"
            class="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent"
            aria-hidden="true"
          />
        </div>
        <div class="text-center mt-7 lg:mt-10">              
          <button @click="isExpanded = !isExpanded" class="btn btn-primary btn-icon-end">
            <span class="my-auto" v-if="!isExpanded">{{ $t('productListing.readMore') }}</span>
            <span class="my-auto" v-if="isExpanded">{{ $t('productListing.readLess') }}</span>
            <i class="icon-arrow-right transform rotate-90" v-if="!isExpanded" aria-hidden="true"></i>
            <i class="icon-arrow-right transform -rotate-90" v-if="isExpanded" aria-hidden="true"></i>

          </button>
        </div>
      </div>
    </div>
  </div>
</template>
